@if (initialized) {
  <form [formGroup]="form">
    <div class="row">
      <div class="col-7">
        <rask-input
          class="col-2"
          aid="mottagningsnummer"
          formControlName="mottagningsplatsnummer"
          label="{{ texts.mottagningsplatsnummer }}"
          [rule]="validation.mottagningsplatsnummer"
        [maxlength]="5"></rask-input>
        <rask-input
          aid="namn"
          class="col-3"
          label="{{ texts.namn }}"
          formControlName="namn"
        [rule]="validation.namn"></rask-input>
        <rask-selector
          class="col-3"
          aid="mottagningsplatstyp"
          formControlName="mottagningsplatstyp"
          label="Mottagningsplatstyp"
          [values]="mottagningsplatsTyper"
          [rule]="validation.mottagningsplatstyp">
        </rask-selector>
        <rask-selector
          class="col-3"
          aid="ansvarigLogistiker"
          [label]="texts.ansvariglogistiker"
          formControlName="ansvarigLogistiker"
          [viewFormatter]="typeAheadViewFormatter"
          [reverseLookup]="false"
          [formatter]="typeAheadValueFormatter"
          [search]="searchLogistikerTypeAhead"
          [itemDisabled]="aktivMetodDisabled">
        </rask-selector>
      </div>
      <div class="col-5">
        <rask-selector
          class="col-4"
          aid="land"
          formControlName="land"
          [label]="texts.land"
          [reverseLookup]="false"
          [viewFormatter]="landViewFormatter"
          [formatter]="landValueFormatter"
          [search]="searchLandTypeAhead"
          [rule]="validation.land"
          [itemDisabled]="landDisabled">
        </rask-selector>
        <rask-checkbox
          aid="egenTerminal"
          class="col-3"
          text="Egen terminal"
          formControlName="egenTerminal"
        [checked]="mottagningsplats.egenTerminal"></rask-checkbox>
        <rask-checkbox
          aid="aktiv"
          class="col-2"
          [text]="texts.aktiv"
          formControlName="aktiv"
        [checked]="mottagningsplats.aktiv"></rask-checkbox>
      </div>
    </div>
    <div class="row">
      <rask-textarea
        aid="beskrivning"
        class="col-12"
        formControlName="beskrivning"
        [label]="texts.beskrivning"
        [rows]="3"
      [maxlength]="1000"></rask-textarea>
    </div>
  </form>
}
